import { CardAssociacoes } from '@/global/components/CardAssociacoes'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import ContentGuide from 'global/guides/ContentGuide/ContentGuide'
import { hasPermission } from 'hooks/useBackendMenu'
import { useState } from 'react'
import { useQuery } from 'react-query'
import { local } from 'service/api'
import { AdicionarFuncionariosLocal } from '../modals/AdicionarFuncionarios'
import { DesassociarFuncionarioLocal } from '../modals/DesassociarFuncionario'

interface Props {
    localId: number
}

/** Funcionários vinculados ao local, com adicionar e remover. */
export function FuncionariosAssociadosLocal({ localId }: Props) {
    const [isAdicionarAberto, setIsAdicionarAberto] = useState(false)
    const canEditar = hasPermission(['update', 'Funcionários'])
    const { data, isLoading } = useQuery(['local', localId], () =>
        local.getById(localId),
    )
    const vinculos = data?.FuncionarioLocais ?? []

    return [
        <CardAssociacoes
            key="lista"
            titulo="Funcionários associados"
            tituloAdicionar="Adicionar funcionários"
            onAdicionar={
                canEditar ? () => setIsAdicionarAberto(true) : undefined
            }
        >
            <div className="min-h-96 w-full flex-1">
                <ContentGuide.DataGrid
                    loading={isLoading}
                    density="compact"
                    className="*:border-none"
                    columns={[
                        {
                            field: 'Funcionario',
                            headerName: 'Nome',
                            flex: 1,
                            valueGetter: ({ value }) => value.nome,
                        },
                        ...(canEditar
                            ? [
                                  {
                                      ...optionsColumn,
                                      field: '__desassociar',
                                      renderCell: DesassociarFuncionarioLocal,
                                  },
                              ]
                            : []),
                    ]}
                    rows={vinculos}
                    ToolbarProps={{ hideToolbar: true }}
                    hideFooter
                />
            </div>
        </CardAssociacoes>,
        <AdicionarFuncionariosLocal
            key="adicionar"
            localId={localId}
            funcionarioIdsAssociados={vinculos.map(item => item.funcionarioId)}
            open={isAdicionarAberto}
            onClose={() => setIsAdicionarAberto(false)}
        />,
    ]
}
